import type { CabAttendanceStatus, CabAttendeeReason } from '../types/cabAttendee';

export const CAB_ATTENDEE_REASON_OPTIONS: Array<{
  value: CabAttendeeReason;
  label: string;
}> = [
  { value: 'cab_manager', label: 'CAB Manager' },
  { value: 'delegate', label: 'Delegate' },
  { value: 'board_member', label: 'CAB Board' },
  { value: 'board_group', label: 'CAB Board Group' },
  { value: 'attendee', label: 'Attendee' },
];

export const CAB_ATTENDANCE_STATUS_OPTIONS: Array<{
  value: CabAttendanceStatus;
  label: string;
}> = [
  { value: 'attending', label: 'Attending' },
  { value: 'no_response', label: 'Awaiting Response' },
  { value: 'not_attending', label: 'Not Attending' },
  { value: 'tentative', label: 'Tentative' },
];

export const CAB_ATTENDANCE_DEFAULT: CabAttendanceStatus = 'no_response';

export function getAttendeeReasonLabel(reason: string): string {
  return CAB_ATTENDEE_REASON_OPTIONS.find((o) => o.value === reason)?.label ?? reason;
}

export function getAttendanceStatusLabel(status: string): string {
  return CAB_ATTENDANCE_STATUS_OPTIONS.find((o) => o.value === status)?.label ?? status;
}
